import { env as clientEnv } from "@/env/client";
import { algoliasearch } from "algoliasearch";

export const algoliaClient = algoliasearch(clientEnv.algoliaAppId, clientEnv.algoliaSearchApiKey);
